import {create} from 'zustand';

type EmergencyTelehealthUnavailableRoomModalStore = {
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
};

export const useEmergencyTelehealthUnavailableRoomModalStore =
	create<EmergencyTelehealthUnavailableRoomModalStore>(set => ({
		isOpen: false,
		onOpen: () => set({isOpen: true}),
		onClose: () => set({isOpen: false}),
	}));
